<template>
    <div class="page-wrapper">
        <NavBar/>
        <router-view></router-view>
    </div>
</template>

<script>
    // @ is an alias to /src
    // import HelloWorld from '@/components/HelloWorld.vue'
    import NavBar from "../components/NavBar";
    import {startReportingLocation, stopReportingLocation} from "../assets/locationReporter";

    export default {
        name: 'Secured',
        components: {
            NavBar
        },
        created: function () {
            this.init();

        },
        methods: {
            init: function () {
                this.$store.dispatch("getShippingMethods");
            }
        },
        mounted() {
            document.body.classList.add("has-navbar-fixed-top")
            // Every logged-in page sits inside this shell, so reporting starts here
            // rather than on the map: whoever is on the road stays on the map even
            // while they work through the orders list.
            startReportingLocation();
        },
        beforeDestroy() {
            // Only ever unmounted on logout, and a logged-out phone has nothing to report.
            stopReportingLocation();
        }
    }
</script>